import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { TimetableGrid } from "@/components/TimetableGrid";
import { ArrowLeft } from "lucide-react";

export default function StudentTimetable() {
    const [tt, setTt] = useState({ slots: [], class_id: null });
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get("/student/timetable"),
            api.get("/subjects"),
        ]).then(([t, s]) => { setTt(t.data); setSubjects(s.data); }).finally(() => setLoading(false));
    }, []);

    return (
        <Layout>
            <Link to="/student" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-oxford mb-4">
                <ArrowLeft className="w-4 h-4" /> Mbrapa
            </Link>
            <div className="mb-6">
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-2">Orari Javor</div>
                <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">Orari im</h1>
            </div>
            {loading ? <div>Duke ngarkuar…</div> : <TimetableGrid slots={tt.slots} subjects={subjects} />}
        </Layout>
    );
}
